<template>
  <div>
    <van-sticky>
      <van-nav-bar :border="false">
        <template slot="left">
          <img :src="homeData.topLogo" alt="" class="logo-site">
        </template>
        <template slot="right">
          <div class="flex align-center">
            <router-link class="relative" to="/message">
              <van-icon name="envelop-o" class="msg" />
              <span v-show="messageCount > 0" class="dot">{{ messageCount }}</span>
            </router-link>
          </div>
        </template>
      </van-nav-bar>
    </van-sticky>

    <div class="main mt-15">
      <van-sticky :offset-top="46">
        <div class="header flex align-center">
          <img :src="userInfo.domain + agentInfo.avatar" alt="" class="img">
          <div class="ml-10">
            <h3>{{ agentInfo.username }}</h3>
            <p class="mt-4">代理类型：{{ agentInfo.type }}</p>
          </div>
        </div>
        <!-- tab栏目 -->
        <div v-if="agentList.length" class="mr-tab">
          <div v-for="(item, index) in tabs" :key="index" class="tab" :class="{ 'active': activeName === item.id}" @click="toggleTab(item.id)">{{ item.name }}</div>
        </div>
        <!-- tab栏目 -->
      </van-sticky>
      <van-pull-refresh v-model="isLoading" class="flex-1" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" @load="onLoad">
          <template v-if="activeName === 0">
            <div v-for="item in list" :key="item.id" class="cell">
              <div class="flex align-center justify-between">
                <div class="flex align-center">
                  <img :src="item.avatar" class="img">
                  <span class="van-ellipsis w-100">{{ item.nickname }}</span>
                </div>
                <span class="fs-12 color-B7BDCA">创建时间：{{ item.jointime * 1000 | formatTime }}</span>
              </div>
              <div class="flex align-center fs-12">
                <span class="mr-16 flex align-center"><img :src="require('@/assets/music@2x.png')" alt="" class="icon"> 上线作品数量：{{ item.issue_music_cnt }}</span>
                <span class="flex align-center"><img :src="require('@/assets/me@2x.png')" alt="" class="icon">状态：<van-tag :type="item.is_verify === 1 ? 'success' : 'danger'">{{ item.is_verify === 1 ? '已实名' : '未实名' }}</van-tag></span>
              </div>
            </div>
          </template>
          <!-- 直属代理 -->
          <template v-else>
            <div v-for="item in agentList" :key="item.id" class="cell flex justify-between align-center">
              <div>
                <div class="flex align-center">
                  <img :src="item.avatar" class="img">
                  <div style="line-height: initial">
                    <h3 class="van-ellipsis fs-16">{{ item.nickname }}</h3>
                    <p class="fs-12 color-B7BDCA mt-6">创建时间：{{ item.jointime * 1000 | formatTime }}</p>
                  </div>
                </div>
                <div class="flex align-center fs-12">
                  <span class="mr-16 flex align-center"><img :src="require('@/assets/music@2x.png')" alt="" class="icon"> 名下实名音乐人：{{ item.cp_cnt }}位</span>
                  <span class="flex align-center"><img :src="require('@/assets/me@2x.png')" alt="" class="icon">状态：<van-tag :type="item.is_verify === 1 ? 'success' : 'danger'">{{ item.is_verify === 1 ? '已实名' : '未实名' }}</van-tag></span>
                </div>
              </div>
              <!-- <div v-show="item.cp_cnt" class="btn-detail" @click="openPop(item.uid)">查看详情</div> -->
            </div>
          </template>
          <template v-if="list.length > 0" #finished>
            <span>没有更多了</span>
          </template>
          <van-empty v-if="(activeName === 0 && list.length === 0) || (activeName === 1 && agentList.length === 0) " description="暂无数据" />
        </van-list>
      </van-pull-refresh>
    </div>
    <van-dialog v-model="popShow" title="查看详情" show-cancel-button cancel-button-text="关闭" :showConfirmButton="false">
      <mr-agent-info :agent="agentDetail"></mr-agent-info>
    </van-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import MrAgentInfo from '@/pages/agent/index/components/agent-info'
import { getHomeData } from '@/api/common.js'
import { getAgentDownNumber, getMusicPerson, getAgentMuiscPerson } from '@/api/agent.js'
export default {
  name: 'AgentDetail',
  components: { MrAgentInfo },
  data() {
    return {
      loading: false,
      isLoading: false,
      finished: true,
      activeName: 0,
      popShow: false, // 代理查看详情
      list: [],
      homeData: {},
      agentList: [], // 直属代理
      agentDetail: [] // 代理详情
    }
  },
  computed: {
    tabs() {
      return [
        { name: '直属音乐人', id: 0 },
        { name: '直属代理', id: 1 }
      ]
    },
    ...mapState(['userInfo', 'agentInfo', 'messageCount'])
  },
  async created() {
    try {
      this.activeName = +this.$route.query.type || 0
      this.TOGGLE_LOADING(true)
      await this.getHomeData()
      await this.getMusicPerson()
      await this.getAgentMuiscPerson()
    } finally {
      this.TOGGLE_LOADING(false)
    }
  },
  methods: {
    async getHomeData() {
      const res = await getHomeData({})
      this.homeData = res.data
    },
    async openPop(uid) {
      this.TOGGLE_LOADING(true)
      const res = await getAgentDownNumber({ uid })
      this.agentDetail = Object.entries(res.data).map(val => ({
        label: val[0],
        value: val[1]
      }))
      this.popShow = true
      this.TOGGLE_LOADING(false)
    },
    async getMusicPerson() {
      const res = await getMusicPerson({ level: 0 })
      this.list = res.data || []
    },
    async getAgentMuiscPerson() {
      const res = await getAgentMuiscPerson({ level: 1 })
      this.agentList = res.data || []
    },
    async onRefresh() {
      await this.getMusicPerson()
      await this.getAgentMuiscPerson()
      this.isLoading = false
    },
    async onLoad() {},
    async toggleTab(id) {
      this.activeName = id
    },
    ...mapMutations(['TOGGLE_LOADING'])
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/home.scss";
.btn-detail{
  border-radius: 8px;
  padding: 0 10px;
  color: #0D0E15;
  background:#F3F4F6;
  border-color: #E0E2E7;
}
.main{
  padding-top: 10px;
  .header{
    padding: 15px;
    background-color: #fff;
  }
  .img{
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  .cell{
    padding: 10px 0;
    margin: 0 15px;
    line-height: 36px;
    &:not(:last-child){
      border-bottom: 1px solid #E0E2E7;
    }
    .img{
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 16px;
    }
  }
}
.mr-tab{
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  background-color: #fff;
  padding: 20px 0;
  box-shadow: 0 -3px 5px 0 rgb(233, 232, 232);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  .tab{
    position: relative;
    color: #B7BDCA;
    width: 140px;
    text-align: center;
    padding-bottom: 10px;
    box-sizing: content-box;
    transition: all .2s;
    &:after{
      content: "";
      position: absolute;
      bottom: 0;
      width: 30px;
      height: 3px;
      left: 50%;
      transform: translateX(-50%);
      transition: all .2s;
      background-color: rgba(0, 0, 0, 0);
      border-radius: 3px;
    }
    &.active{
      color: #0D0E15;
      &:after{
        background-color: #ee0a24;
      }
    }
  }
}
.icon{
  width: 16px;
  margin-right: 5px;
}
</style>
